<div class="mibi-order-results">
    <!-- Three-part bar: the side groups share the space equally, which keeps the
         order-switch control in the true horizontal middle until the NRL
         tabs outgrow their half and push it to the right. -->
    <div class="mibi-order-results__bar">
        <div class="mibi-order-results__bar-left">
            <div class="mibi-order-results__meta">
                <span class="mibi-order-results__date">{{ createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
                <span class="mibi-order-results__file">{{ order?.fileName }}</span>
            </div>

            <nav class="mibi-order-results__tabs">
                @for (tab of nrlTabs; track tab.id) {
                    <button
                        type="button"
                        class="mibi-order-results__tab"
                        [class.mibi-order-results__tab--active]="tab.id === selectedNrlId"
                        [mibiToolTip]="toolTipsOf(tab)"
                        (click)="onSelectNrl(tab.id)"
                    >{{ tab.label }}</button>
                }
            </nav>
        </div>

        <!-- One control with two halves: left switches to newer orders,
             right to older ones (mockup #4). -->
        <div class="mibi-order-results__orders">
            <button
                class="mibi-order-results__order-nav"
                type="button"
                [disabled]="!hasNewerOrder"
                (click)="onOpenNewerOrder()"
            >
                <span>Neuere Aufträge</span>
                <mat-icon [inline]="true" class="mibi-order-results__order-nav-icon">arrow_back</mat-icon>
            </button>
            <button
                class="mibi-order-results__order-nav"
                type="button"
                [disabled]="!hasOlderOrder"
                (click)="onOpenOlderOrder()"
            >
                <mat-icon [inline]="true" class="mibi-order-results__order-nav-icon">arrow_forward</mat-icon>
                <span>Ältere Aufträge</span>
            </button>
        </div>

        <div class="mibi-order-results__bar-right">
            <button
                class="mibi-order-results__download"
                type="button"
                [matMenuTriggerFor]="downloadMenu"
            >
                <mat-icon [inline]="true" class="mibi-order-results__download-icon">assignment_returned</mat-icon>
                <span>Ergebnisse herunterladen</span>
                <mat-icon [inline]="true" class="mibi-order-results__download-icon">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #downloadMenu="matMenu">
                <button mat-menu-item type="button" (click)="onDownloadDisplayed()">Ergebnisse des angezeigten Labors herunterladen</button>
                <button mat-menu-item type="button" (click)="onDownloadAll()">Ergebnisse aller Labore zu diesem Auftrag herunterladen</button>
            </mat-menu>
        </div>
    </div>

    <div class="mibi-order-results__content" (click)="onGridClick($event)">
        @if (model) {
            <!-- Recreate the grid when switching results/full-data mode: the reused
                 data-grid mis-renders data cells when the column set changes while
                 the rows stay the same. Tracking the mode forces a fresh grid. -->
            @for (mode of [showFullData]; track mode) {
                <mibi-samples-grid-view
                    mibiToggleBarHeight
                    [model]="model"
                    [style.--mibi-grid-cols]="columnTemplate"
                ></mibi-samples-grid-view>
            }
        }
    </div>
</div>
